// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/link/link.component.scss
// module id = 399
// module chunks = 0